export const pickFilterOptions = <TOption extends string>({
  options,
  values,
}: {
  options: readonly TOption[];
  values: readonly string[];
}): TOption[] => options.filter((option) => values.includes(option));
